import { render, staticRenderFns } from "./UpdateApp.vue?vue&type=template&id=1e45968b&scoped=true&"
import script from "./UpdateApp.vue?vue&type=script&lang=ts&"
export * from "./UpdateApp.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateApp.vue?vue&type=style&index=0&id=1e45968b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45968b",
  null
  
)

export default component.exports